import * as vouchersAPI from '../api/vouchers';
import { fetchLoadable } from '../fetchLoadable';
export const getVoucherTypes = () => fetchLoadable('FETCH_ECONOMY_VOUCHER_TYPES', vouchersAPI.getTypes);
//# sourceMappingURL=actions.js.map